import buildSignatureBlocks from "./helpers/buildSignatureBlocks";
import getFullNamesFromArray from "./helpers/getFullNamesFromArray";
import removeSection from "./helpers/removeSection";
import setDayOfWeek from "./helpers/setDayOfWeek";
import { combineBrokersFirmName, enablePurchasePriceForTitleCompany, extractEmailsAndPhones, handleDifferentKeyOfClient, handleSignatureCompletion, makeFieldsHiddenForTitleCompany, removeAddButtonForReadOnly, showClientsListWithSeperateInputs, showCompanyDetails, updateBrokerFirmList, updateBrokerList, updateSection3Fields } from "./helperFunctions";
import imagePlaceholder from "../../Assets/Icons/imagePlaceholder.webp";
import { addDynamicSellerBuyer } from "./helpers/dynamicSellerBuyerTitleOrder";
import { formatDate, formatPhoneNumber, getcombinedClientsAndAgents, getEmailsList, getCombinedFullNameAndEmailsFromArray } from "../../Common/utils/universalFuntions";
import { transactionReportDynamicFields } from "./helpers/transactionReportDynamicFields";
import { buildAgentSignatureLabels, buildSignatureLabels, convertTime, counterOfferContractTypes, createOfferContractTypes, listingContractTypes } from "../../Common/commondata/commonData";
import { checkDynamicFieldsOfNetSheet } from "./helpers/netSheetDynamicComponents";
import { calculateFinalNetSheetPrice, calculateNetSheetAmtWyomingBuying, calculateNetSheetAmtWyomingSelling, calculateTheAnnualAmount, checkBrokerageFee, handleMortgageCalculation } from "./helpers/netsheetAmtCalculater";
import { contractStoreHandle } from "../../ContractStore/state/actions";
import buildDynamicBlocksForReferalForm from "./helpers/buildDynamicBlocksForReferalForm";
import buildSignatureBlocksForAgents from "./helpers/buildSignatureBlocksForAgents";
import { dynamicHTMLUpdate } from "./helpers/dynamicHTMLUpdate";
import { checkForInitials } from "./helpers/createInitials";
import accounting from "accounting";

const SetInitialValues = ({ contractData, currentUrlId, rootDocData, getTransactionReportData, transactionEmail, CurrentPdfImportData, sharedDocs, source, dispatch, contractAuthKey, getEmailLogsData }) => {
  // filling all the values
  let td = {};
  dynamicHTMLUpdate({ rootDocData });
  if (rootDocData?.contractType === "TR") {
    td = getTransactionReportData?.transactionData || {};

    if (getTransactionReportData) {
      // RE-Sure TRANSACTION DOCUMENTS
      transactionReportDynamicFields(getTransactionReportData?.documentsData, "DOCUMENTS");

      // Signature Details
      transactionReportDynamicFields(getTransactionReportData?.documentsData, "SIGNATURE_DETAILS");

      const clientData = getcombinedClientsAndAgents({ allContractDocuments: getTransactionReportData?.documentsData });

      // Buyers details
      addDynamicSellerBuyer({clientType: "Buyers", clientArray: clientData?.combinedBuyerIds, contractType: rootDocData.contractType, openFor: rootDocData?.openFor});

      // Sellers details
      addDynamicSellerBuyer({clientType: "Sellers", clientArray: clientData?.combinedSellerIds, contractType: rootDocData.contractType, openFor: rootDocData?.openFor});
    }
    if (transactionEmail) {
      // Email Communications
      transactionReportDynamicFields(transactionEmail, "EMAIL_COMMUNICATIONS");
    }
    if (getEmailLogsData) {
      // Email Communications
      transactionReportDynamicFields(getEmailLogsData, "EMAIL_LOGS");
    }
    if (sharedDocs) {
      // shared documents table
      transactionReportDynamicFields(sharedDocs, "SHARED_DOCS");
    }
  } else if (source === "OFFER_IMPORT" && CurrentPdfImportData) {
    td = CurrentPdfImportData;
  } else {
    td = JSON.parse(localStorage.getItem(currentUrlId));
  }

  let fillValueFor = null; // The Person who selected title company
  // console.log("checking oof no of times calling", rootDocData?.contractType, );
  if (td && Object.keys(td)?.length > 0) {
    if (rootDocData?.contractType === "TO") {
      // adding placeholder image for title office in TO form if office not selected
      if (!td["TitleCompanyLogo"]) {
        const titleOfficeImageElement = Array.from(document.getElementsByName("TitleCompanyLogo"))?.[0];
        if (titleOfficeImageElement) titleOfficeImageElement.src = imagePlaceholder;
      }

      // If there is a single sellerAgent and buyerAgent (and both are the same) in the transaction:
      if (td["SellerAgents"]?.length === 1 && td["BuyerAgents"]?.length === 1 && td["SellerAgents"]?.[0]?.personId === td["BuyerAgents"]?.[0]?.personId) {
        fillValueFor = rootDocData?.titleCompanyDetails?.selectedBy || fillValueFor;
      }

      if ((fillValueFor === null && (td["SellerAgents"]?.length > 1 || td["BuyerAgents"]?.length > 1)) || td["SellerAgents"]?.[0]?.personId !== td?.["BuyerAgents"]?.[0]?.personId) {
        const doubleSidedTransactionCheckbox = document.getElementsByName("DoubleSidedTransaction")?.[0];
        if (doubleSidedTransactionCheckbox) {
          doubleSidedTransactionCheckbox.disabled = true; // In case of multiple agents, disable it.
        }
      }
      // setting populated data for TO like TR
      const clientData = getcombinedClientsAndAgents({ allContractDocuments: getTransactionReportData?.documentsData });
      if (clientData?.combinedBuyerIds?.length) td["Buyers"] = clientData?.combinedBuyerIds;
      if (clientData?.combinedSellerIds?.length) td["Sellers"] = clientData?.combinedSellerIds;
    }
    if (rootDocData?.contractType === "NET_SHEET") {
      checkDynamicFieldsOfNetSheet(td);
      let dataToSet = calculateFinalNetSheetPrice({ td });
      if (dataToSet && Object.keys(dataToSet).length > 0) {
        td = { ...td, ...dataToSet };
      }

      // Remove visibility of some fields in NetSheet for Title Company
      if (["TITLE_COMPANY", "SELLER_AGENT"].includes(rootDocData?.openFor)) {
        enablePurchasePriceForTitleCompany();
        if (["TITLE_COMPANY"].includes(rootDocData?.openFor)) {
          makeFieldsHiddenForTitleCompany();
        }
      }

      // Remove buttons for read only document and for buyer agent
      if (!(((rootDocData?.RTDInitiator === "SELLER" && ["SELLER_AGENT", "TITLE_COMPANY", "SELLER"].includes(rootDocData?.openFor)) || (rootDocData?.RTDInitiator === "BUYER" && ["SELLER_AGENT", "TITLE_COMPANY", "BUYER_AGENT", "BUYER"].includes(rootDocData?.openFor))) && rootDocData?.builtForSection === "DOCUMENT") || rootDocData?.builtForSection === "READ_ONLY_DOCUMENT") {
        removeAddButtonForReadOnly();
      }
    }
    if (rootDocData?.contractType === "WY_NET_SHEET") {
      let { NetProceedsFromSale, EstimatedCostOfSales } = calculateNetSheetAmtWyomingSelling({ td, calculationFixedKeys: contractData?.calculationFixedKeys });
      td = { ...td, NetProceedsFromSale, EstimatedCostOfSales };
      let dataToSet = checkBrokerageFee({ td, source: "SET_INITIAL_VALUES" });
      if (dataToSet && Object.keys(dataToSet).length > 0) {
        td = { ...td, ...dataToSet };
      }
    }
    if (rootDocData?.contractType === "WY_BGFE") {
      // CALCULATE ANNUAL AMOUNT
      let dataToSet = calculateTheAnnualAmount({ td, source: "SET_INITIAL_VALUES" });
      if (dataToSet && Object.keys(dataToSet).length > 0) {
        td = { ...td, ...dataToSet };
      }
      // handleMortgageCalculation
      if (td["FirstMortgage"] && td["FirstMortgageAnnualInterestRate"] && td["FirstMortgageTermOfLoanInYears"] && ["0", 0, "0.00", "", null, undefined].includes(td["FirstMortgagePrincipalAndInterest"])) {
        let FirstMortgagePrincipalAndInterest = handleMortgageCalculation({ prefix: "First", td });
        td = { ...td, FirstMortgagePrincipalAndInterest };
      }
      if (td["SecondMortgage"] && td["SecondMortgageAnnualInterestRate"] && td["SecondMortgageTermOfLoanInYears"] && ["0", 0, "0.00", "", null, undefined].includes(td["SecondMortgagePrincipalAndInterest"])) {
        let SecondMortgagePrincipalAndInterest = handleMortgageCalculation({ prefix: "Second", td });
        td = { ...td, SecondMortgagePrincipalAndInterest };
      }
      // Final Amount
      let finalData = calculateNetSheetAmtWyomingBuying({ td, calculationFixedKeys: contractData?.calculationFixedKeys });
      if (finalData && Object.keys(finalData).length > 0) {
        td = { ...td, ...finalData };
      }
    }

    updateBrokerList({ localData: td, rootDocData, source: "SET_INITIAL_VALUES" });
    for (const key in td) {
      const savedValue = td[key];
      const localTD = td;
      if ((key === "Buyers" || key === "Sellers") && rootDocData?.builtForSection !== "TEMPLATE" && rootDocData?.builtForSection !== "DOCUMENT_SET") {
        const singularKey = key === "Buyers" ? "BUYER" : "SELLER";
        const normalClients = savedValue.filter((client) => !client.labelType || client.labelType === "NORMAL");
        const clientStr = getFullNamesFromArray(normalClients);
        const elements = document.querySelectorAll(`[data-${key.toLowerCase()}-list]`);
        let buildDynamicBlocks = "";
        if (rootDocData?.contractType === "BHHS_CP_RA") {
          buildDynamicBlocks = buildDynamicBlocksForReferalForm({ clientsArray: normalClients, type: "CLIENT", RTDInitiator: rootDocData?.RTDInitiator });
        }
        if (elements.length) {
          elements.forEach((element) => {
            if (source === "OFFER_IMPORT" || rootDocData?.contractType === "BHHS_CP_RA") {
              element.innerHTML = rootDocData?.contractType === "BHHS_CP_RA" ? buildDynamicBlocks : clientStr;
            } else {
              element.value = clientStr;
            }
            element.parentNode.dataset.replicatedValue = clientStr;
          });
        }
         if (rootDocData?.contractType === "WY_CCS") {
          showClientsListWithSeperateInputs({ clientsArray: normalClients, clientKey: key });
        }
        const elementsFrimWithPreSuffix = document.querySelectorAll(`[data-${key.toLowerCase()}-firm-list]`);
        // console.log("elementsWithPreSuffix", elementsWithPreSuffix);
        if (elementsFrimWithPreSuffix.length) {
          const firmStr = combineBrokersFirmName(normalClients, "CLIENTS");
          elementsFrimWithPreSuffix?.forEach((element) => {
            element.value = firmStr;
            element.parentNode.dataset.replicatedValue = firmStr;
          });
        }
        const additionalClientInfo = contractData?.additionalClientInfo ?? {};
        const categorizedClients = {};
        Object.keys(additionalClientInfo).forEach((clientKey) => {
          categorizedClients[clientKey] = savedValue.filter((client) => client.labelType === additionalClientInfo[clientKey]?.default?.labelType);
        });

        Object.entries(categorizedClients).forEach(([clientKey, clients]) => {
          const clientStr = getFullNamesFromArray(clients);
          const elementsWithPreSuffix = document.querySelectorAll(`[data-${key.toLowerCase()}-list-${clientKey}]`);
          const elementsFrimWithPreSuffix = document.querySelectorAll(`[data-${key.toLowerCase()}-firm-list-${clientKey}]`);
          if (elementsFrimWithPreSuffix.length) {
            const firmStr = combineBrokersFirmName(clients, "CLIENTS");
            elementsFrimWithPreSuffix?.forEach((element) => {
              element.value = firmStr;
              element.parentNode.dataset.replicatedValue = firmStr;
            });
          }
          
          if (rootDocData?.contractType === "WY_RLC") {
            const elementsEmailWithPreSuffix = document.querySelectorAll(`[data-${key.toLowerCase()}-email-list-${clientKey}]`);
            const elementsPhoneNumbersWithPreSuffix = document.querySelectorAll(`[data-${key.toLowerCase()}-phone-list-${clientKey}]`);
            const { emailList, phoneNumberList } = extractEmailsAndPhones(clients ||[]);
            elementsEmailWithPreSuffix.forEach((element) => {
              element.value = emailList || "";
              element.parentNode.dataset.replicatedValue = emailList || "";
            });
            elementsPhoneNumbersWithPreSuffix.forEach((element) => {
              element.value = phoneNumberList || "";
              element.parentNode.dataset.replicatedValue = phoneNumberList || "";
            });
          }
          let buildDynamicBlocks = "";
          if (rootDocData?.contractType === "BHHS_CP_RA") {
            buildDynamicBlocks = buildDynamicBlocksForReferalForm({ clientsArray: clients, type: "AGENT", labelType: additionalClientInfo[clientKey]?.default?.labelType, RTDInitiator: rootDocData?.RTDInitiator });
            if (key === "Buyers") {
              let dataselector = `[data-${key.toLowerCase()}-company-label-type="${additionalClientInfo?.[clientKey]?.default?.labelType}"]`;
              updateBrokerFirmList({ clientsArray: clients, dataselector, localData: localTD });
            }
          }
          elementsWithPreSuffix.forEach((element) => {
            if (rootDocData?.contractType === "BHHS_CP_RA") {
              element.innerHTML = buildDynamicBlocks;
            } else {
              element.value = clientStr;
              element.parentNode.dataset.replicatedValue = clientStr;
            }
          });
        });

        let i = 0;
        while (true) {
          const iterationIndex = i;
          const signatureBlockName = iterationIndex ? `${singularKey}_${iterationIndex}` : singularKey;
          const signatureElements = document.querySelectorAll(`[data-signature-block="${signatureBlockName}"]`);
          let hasValidSignatureBlock = signatureElements.length > 0;
          Object.keys(categorizedClients).forEach((clientKey) => {
            const clientSignatureBlockName = `${singularKey}-${clientKey}${iterationIndex ? `_${iterationIndex}` : ""}`;
            if (document.querySelector(`[data-signature-block="${clientSignatureBlockName}"]`)) {
              hasValidSignatureBlock = true;
            }
          });

          if (!hasValidSignatureBlock) break; // if No signatures are found at all.
          // Building signature blocks for normal clients
          if (signatureElements.length) {
            const signers = handleDifferentKeyOfClient({ clientArray: normalClients, i: iterationIndex });
            let withdrawSignEnabled = {};
            if (key === "Buyers") {
              const withdrawSignAllowed = td?.["LetBuyersSignWithDrawBlock"];
              const buyerWithDrawPresent = contractData?.signatureSequence?.buyerWithdraw;
              if (iterationIndex > 0 && buyerWithDrawPresent && !withdrawSignAllowed) {
                withdrawSignEnabled = { checkForDisable: { disabled: true } };
              }
            }
            let signerFields = buildSignatureLabels({type: key, contractData});
            const dataObj = {
              signers,
              type: key,
              rootDocData: {
                ...rootDocData,
                ...withdrawSignEnabled,
                personKey: `${rootDocData?.builtForId}${iterationIndex ? `_${iterationIndex}` : ""}`,
                key: `${rootDocData?.key}${iterationIndex ? `_${iterationIndex}` : ""}`,
              },
              requiredOpenFor: singularKey,
              contractData,
              signerFields: signerFields?.[i] || signerFields?.default
            }
            const sigBlock = buildSignatureBlocks(dataObj);

            signatureElements.forEach((element) => {
              element.innerHTML = sigBlock;
            });

            // FOR WYOMING CONTRACTS, CHECK FOR INITIALS
            if (rootDocData?.contractType?.startsWith("WY")) {
              checkForInitials(dataObj);
            }
          }

          // Building signature blocks for additional clients
          Object.entries(categorizedClients).forEach(([clientKey, clients]) => {
            const clientSignatureBlockName = `${singularKey}-${clientKey}${iterationIndex ? `_${iterationIndex}` : ""}`;
            const clientSignatureElements = document.querySelectorAll(`[data-signature-block="${clientSignatureBlockName}"]`);
            if (clientSignatureElements.length) {
              const clientSigners = handleDifferentKeyOfClient({ clientArray: clients, i: iterationIndex });
              let signerFields = buildSignatureLabels({type: key, contractData, signDetails: additionalClientInfo, signDetailsKey: clientKey});
              const clientSigBlock = buildSignatureBlocks({
                signers: clientSigners,
                type: key,
                rootDocData: {
                  ...rootDocData,
                  personKey: `${rootDocData?.builtForId}${iterationIndex ? `_${iterationIndex}` : ""}`,
                  key: `${rootDocData?.key}${iterationIndex ? `_${iterationIndex}` : ""}`,
                },
                requiredOpenFor: singularKey,
                contractData,
                signerFields: signerFields?.[iterationIndex] || signerFields?.default
              });
              clientSignatureElements.forEach((element) => {
                element.innerHTML = clientSigBlock;
              });
            }
          });
          i++;
        }

        if (rootDocData?.contractType === "TO" && Array.isArray(normalClients) && normalClients.length) {
          let dataToSave = addDynamicSellerBuyer({clientType: key, clientArray: normalClients, contractType: rootDocData.contractType, td, openFor: rootDocData?.openFor});
          td = { ...td, ...dataToSave };
          localStorage.setItem(currentUrlId, JSON.stringify(td));
        }
        if (rootDocData?.contractType === "CB_NOCOLS") {
          if (key === "Sellers" && savedValue?.length) {
            const sellersEmailsList = getEmailsList({ savedValue, type: "emailOnRootLevel" });
            const elements = document.querySelectorAll(`[data-sellers-email-list]`);
            elements.forEach((element) => {
              element.value = sellersEmailsList?.join(",\n");
              element.parentNode.dataset.replicatedValue = element.value;
            });
            td["SellerEmailList"] = sellersEmailsList?.join(",\n");
            localStorage.setItem(currentUrlId, JSON.stringify(td));
          }
        }
      } else if ((key === "BuyerAgents" || key === "SellerAgents") && rootDocData?.builtForSection !== "TEMPLATE" && rootDocData?.builtForSection !== "DOCUMENT_SET") {
        let shouldUpdateFields = (key === "BuyerAgents" && !["CRE_RE"].includes(rootDocData?.contractType)) || (key === "SellerAgents" && ![...listingContractTypes, "CRE_LA"].includes(rootDocData?.contractType));
        shouldUpdateFields = rootDocData?.contractType?.startsWith("DC_") || rootDocData?.contractType?.startsWith("WY_") ? !rootDocData.documentId : shouldUpdateFields;
        if (shouldUpdateFields) {
          updateSection3Fields({ localData: td, agents: savedValue, agentType: key, rootDocData });
        }
        const agentTypeKey = key === "BuyerAgents" ? "buyer-brokers" : "seller-brokers";
        const normalAgents = savedValue.filter((agent) => !agent.labelType || agent.labelType === "NORMAL");
        const additionalAgentInfo = contractData?.additionalAgentInfo ?? {};
        const categorizedAgents = {};
        Object.keys(additionalAgentInfo).forEach((agentKey) => {
          categorizedAgents[agentKey] = savedValue.filter((client) => client.labelType === additionalAgentInfo?.[agentKey]?.default?.labelType);
        });

        Object.entries(categorizedAgents).forEach(([agentKey, agents]) => {
          const agentStr = getFullNamesFromArray(agents);
          const elementsWithPreSuffix = document.querySelectorAll(`[data-${agentTypeKey.toLowerCase()}-list-${agentKey}]`);
          elementsWithPreSuffix.forEach((element) => {
            element.value = agentStr;
            // console.log("elementsWithPreSuffix, element", element.name);
            element.parentNode.dataset.replicatedValue = agentStr;
          });
        });
        const agentType = key === "BuyerAgents" ? "CO_BUYER_BROKER" : "CO_SELLER_BROKER";

        let i = 0;
        while (true) {
          const iterationIndex = i;
          const signatureBlockName = iterationIndex ? `${agentType}_${iterationIndex}` : agentType;
          const signatureElements = document.querySelectorAll(`[data-signature-block="${signatureBlockName}"]`);
          let hasValidSignatureBlock = signatureElements.length > 0;

          Object.keys(categorizedAgents).forEach((agentKey) => {
            const clientSignatureBlockName = `${signatureBlockName}-${agentKey}`;
            if (document.querySelector(`[data-signature-block="${clientSignatureBlockName}"]`)) {
              hasValidSignatureBlock = true;
            }
          });

          if (!hasValidSignatureBlock) break; // if No signatures are found at all.
          // Building signature blocks for normal agents
          if (signatureElements.length && normalAgents.length) {
            const currentBuyerClient = handleDifferentKeyOfClient({ clientArray: normalAgents, i, source: "AGENT" });
            let brokerFields = buildAgentSignatureLabels({type: agentType, contractData});
            const sigBlock = buildSignatureBlocksForAgents({
              signers: currentBuyerClient,
              type: agentType,
              rootDocData: {
                ...rootDocData,
                personKey: `${rootDocData?.builtForId}${iterationIndex ? `_${iterationIndex}` : ""}`,
                key: `${rootDocData?.key}${iterationIndex ? `_${iterationIndex}` : ""}`,
              },
              contractData,
              requiredOpenFor: key === "BuyerAgents" ? "BUYER_AGENT" : "SELLER_AGENT",
              brokerFields: brokerFields?.[i] || brokerFields?.default
            });
            signatureElements.forEach((element) => {
              element.innerHTML = sigBlock;
            });
          }

          // Building signature blocks for additional agents
          Object.entries(categorizedAgents).forEach(([agentKey, agents]) => {
            const clientSignatureBlockName = `${signatureBlockName}-${agentKey}`;
            const clientSignatureElements = document.querySelectorAll(`[data-signature-block="${clientSignatureBlockName}"]`);
            if (clientSignatureElements.length) {
              const currentBuyerClient = handleDifferentKeyOfClient({ clientArray: agents, i: iterationIndex });
              let brokerFields = buildAgentSignatureLabels({type: agentType, contractData, signDetails: additionalAgentInfo, signDetailsKey: agentKey});
              const sigBlock = buildSignatureBlocksForAgents({
                signers: currentBuyerClient,
                type: agentType,
                rootDocData: {
                  ...rootDocData,
                  personKey: `${rootDocData?.builtForId}${iterationIndex ? `_${iterationIndex}` : ""}`,
                  key: `${rootDocData?.key}${iterationIndex ? `_${iterationIndex}` : ""}`,
                },
                contractData,
                requiredOpenFor: key === "BuyerAgents" ? "BUYER_AGENT" : "SELLER_AGENT",
                brokerFields: brokerFields?.[iterationIndex] || brokerFields?.default
              });
              clientSignatureElements.forEach((element) => {
                element.innerHTML = sigBlock;
              });
            }
          });
          i++;
        }
        if ((rootDocData?.contractType === "TO" || rootDocData?.contractType === "TR") && Array.isArray(savedValue) && savedValue.length) {
          if (rootDocData?.contractType === "TO" && ((key === "BuyerAgents" && fillValueFor === "SELLER_AGENT") || (key === "SellerAgents" && fillValueFor === "BUYER_AGENT")) && !td["DoubleSidedTransaction"]) {
            let obj = savedValue[0];
            Object.keys(obj).forEach((key) => {
              if (key !== "personId") {
                obj[key] = "";
              }
            });
          }
          addDynamicSellerBuyer({clientType: key, clientArray: savedValue, contractType: rootDocData?.contractType, openFor: rootDocData?.openFor});
        }
        if (source === "OFFER_IMPORT" && CurrentPdfImportData) {
          const nameEmailStr = getCombinedFullNameAndEmailsFromArray(savedValue);
          const emailElements = document.querySelectorAll("[data-buyer-agents-with-email-list]");
          if (emailElements) {
            emailElements.forEach((element) => {
              element.innerHTML = nameEmailStr;
              element.parentNode.dataset.replicatedValue = nameEmailStr;
            });
          }
        }
      } else if (key === "TitleCompanyLogo") {
        const titleOfficeImageElement = document.getElementsByName("TitleCompanyLogo")[0];
        if (savedValue && titleOfficeImageElement) {
          titleOfficeImageElement.src = savedValue;
        }
      } else if (rootDocData?.contractType === "CB_NOCOLS" && ["TitleCompanyName", "TitleCloserName", "TitleCloserEmail", "TitleCloserPhone", "SalesRepName", "SalesRepEmail", "SalesRepPhone"].includes(key)) {
        const titleSettlementCoName = document.getElementsByName(`TitleCompanyName`)[0];
        const titleSettlementCoContactName = document.getElementsByName(`TitleCompanyContactName`)[0];
        const titleSettlementCoEmail = document.getElementsByName(`TitleCompanyEmail`)[0];
        const titleSettlementCoPh = document.getElementsByName(`TitleCompanyPhoneNumber`)[0];
        titleSettlementCoName.value = td["TitleCompanyName"];
        titleSettlementCoName.parentNode.dataset.replicatedValue = td["TitleCompanyName"];
        if (td["TitleCloserName"]?.length) {
          titleSettlementCoContactName.value = td["TitleCloserName"];
          titleSettlementCoContactName.parentNode.dataset.replicatedValue = td["TitleCloserName"];
          titleSettlementCoEmail.value = td["TitleCloserEmail"];
          titleSettlementCoEmail.parentNode.dataset.replicatedValue = td["TitleCloserEmail"];
          titleSettlementCoPh.value = td["TitleCloserPhone"];
          titleSettlementCoPh.parentNode.dataset.replicatedValue = td["TitleCloserPhone"];
        } else if (td["SalesRepName"]?.length) {
          titleSettlementCoContactName.value = td["SalesRepName"];
          titleSettlementCoContactName.parentNode.dataset.replicatedValue = td["SalesRepName"];
          titleSettlementCoEmail.value = td["SalesRepEmail"];
          titleSettlementCoEmail.parentNode.dataset.replicatedValue = td["SalesRepEmail"];
          titleSettlementCoPh.value = td["SalesRepPhone"];
          titleSettlementCoPh.parentNode.dataset.replicatedValue = td["SalesRepPhone"];
        }
      } else {
        if (Array.isArray(savedValue)) {
          savedValue.forEach((value) => {
            // console.log("checking if", savedValue, " is selected");
            document.getElementsByName(key).forEach((element, i) => {
              if (element.value === value) {
                element.checked = true;
              }
              if (element.type === "checkbox") {
                if (element.value === savedValue) {
                  element.checked = true;
                }
                if (element.hasAttribute("data-remove-target") && i === 0) {
                  // console.log("section deleted. removing section for", element.name);
                  removeSection(element);
                }
                // if deleted or No Change checkbox is checked already
                if (["No Change", "Deleted"].includes(element.value) && element.checked) {
                  let table31Inputs = document.getElementsByName(element.name);
                  if (table31Inputs && table31Inputs[0]) {
                    table31Inputs[0].value = "";
                  }
                }
              } else {
                if (element.tagName === "TEXTAREA") {
                  element.value = savedValue?.map((item, index) => `${index + 1}. ${item}`).join("\n");
                  element.parentNode.dataset.replicatedValue = element.value;
                } else if (element.tagName === "INPUT" && !counterOfferContractTypes.includes(rootDocData?.contractType)) {
                  element.value = savedValue?.join(", ");
                  element.parentNode.dataset.replicatedValue = element.value;
                }
              }
            });
          });
        } else if (typeof savedValue === "object") {
          const elements = document.getElementsByName(key);
          if (elements) {
            elements.forEach((element, i) => {
              // console.log("element for relative date", element);
              if (element.type !== "checkbox") {
                if ((rootDocData?.builtForSection === "TEMPLATE" || rootDocData?.documentType === "TEMPLATE") && savedValue && savedValue.type === "OCD") {
                  if (savedValue?.relation) {
                    element.value = Math.abs(savedValue.value) ? `${Math.abs(savedValue.value)} ${savedValue?.relation}` : `${savedValue?.relation}`;
                  }
                } else if (savedValue && savedValue.type === "date") {
                  element.value = formatDate(savedValue.value);
                  if (element.hasAttribute("data-setdayofweek") && i === 0) {
                    setDayOfWeek({
                      name: element.name,
                      value: element.value,
                    });
                  }
                } else if (savedValue && savedValue?.type === "mec") {
                  element.value = `${savedValue.value} days after MEC`;
                  if (element.hasAttribute("data-setdayofweek") && i === 0) {
                    setDayOfWeek({
                      name: element.name,
                      value: "",
                    });
                  }
                } else if (savedValue && savedValue.type === "text") {
                  element.value = savedValue.value;
                  if (element.hasAttribute("data-setdayofweek") && i === 0) {
                    setDayOfWeek({
                      name: element.name,
                      value: "",
                    });
                  }
                } else if (savedValue && savedValue.type === "time") {
                  element.value = convertTime(savedValue.value);
                }
                if (element.parentNode.classList.contains("grow-with-input")) {
                  element.parentNode.dataset.replicatedValue =["date", "text"].includes(savedValue?.type) ? savedValue?.value : savedValue;
                }
              } else {
                element.checked = false;
              }
            });
          }
        } else {
          // it is a single value
          const elements = document.getElementsByName(key);
          if (elements) {
            elements.forEach((element, i) => {
              if (element.type === "checkbox") {
                if (element.value === savedValue) {
                  element.checked = true;
                } else {
                  element.checked = false;
                }
                if (element.hasAttribute("data-remove-target") && i === 0) {
                  // console.log("section deleted. removing section for", element.name);
                  removeSection(element);
                }
              } else {
                if (element.classList.contains("relativeDateInput") && !isNaN(Date.parse(savedValue)) && element.type !== "date") {
                  element.value = formatDate(savedValue);
                } else if (element.classList.contains("relativeTimeInput")) {
                  element.value = convertTime(savedValue);
                } else if (!element.hasAttribute("data-not-autofill-values")) {
                  element.value = savedValue;
                }
                if (element.parentNode.classList.contains("grow-with-content") || element.parentNode.classList.contains("grow-with-input")) {
                  element.parentNode.dataset.replicatedValue = savedValue;
                }
                if (element.hasAttribute("data-setdayofweek") && i === 0) {
                  setDayOfWeek({
                    name: element.name,
                    value: element.value,
                  });
                }
                if (element.hasAttribute("data-linked-value") && savedValue) {
                  // console.log("element has linked value... setting", ele);
                  const ele = document.querySelector(`[name="${element.dataset.linkedValue}"][data-linked-value="${key}"]`);
                  if (ele) {
                    ele.value = savedValue;
                    ele.checked = true;
                    if (ele.hasAttribute("data-cb-group")) {
                      // Note:- if name and data-cb-group=? is equal then only it will work, otherwise need to remove👇this [data-cb-group="${ele?.name}"] from below
                      const groupElements = document.querySelectorAll(`[name="${ele?.name}"][data-cb-group="${ele?.name}"][type="checkbox"]`);
                      groupElements.forEach((e) => {
                        if (e.value !== ele.value) {
                          // console.log("elements to be unchecked", e);
                          e.checked = false;
                        }
                      });
                    }
                  }
                }
                if (element.hasAttribute("data-enable-target") && savedValue) {
                  // console.log("element has enable target... setting", element.dataset?.enableTarget, savedValue);
                  document.querySelectorAll(`[data-enable-source="${element.dataset?.enableTarget}"][type="checkbox"]`).forEach((ele) => {
                    // console.log("element ", ele);
                    ele.checked = true;
                  });
                }

                if (element.classList.contains("formatPhoneNumber") && savedValue) {
                  element.value = formatPhoneNumber(element.value);
                }
                if (element.classList.contains("currency") && savedValue) {
                  const formattedPrice = accounting.formatNumber(savedValue, 2);
                  element.value = formattedPrice;
                  if (element.parentNode?.classList?.contains("grow-with-input")) {
                    element.parentNode.dataset.replicatedValue = formattedPrice;
                  }
                }
              }
            });
          }
        }
      }
    }

    // To Show the Agent's Office details
    if (!["TR", "TO"].includes(rootDocData?.contractType) && rootDocData?.builtForSection !== "TEMPLATE" && rootDocData?.builtForSection !== "DOCUMENT_SET") {
      showCompanyDetails(td, rootDocData);
    }
    //For closing company
    if (["CI", "HH_CRA", "HH_LRA"].includes(rootDocData?.contractType)) {
      let signedTitleCompany = rootDocData?.signatureInfo?.find((ele) => ele.roleType === "TITLE_COMPANY");
      let signerDetails = {
        key: signedTitleCompany?.key || rootDocData?.email,
        fullName: td.TitleCompanySignedBy || (rootDocData?.openFor === "TITLE_COMPANY"? rootDocData?.fullName : ""),
       };
       let signers = [signerDetails];
      if (td?.TitleReps?.length > 0) {
        signers = td.TitleReps.map((rep, index) => ({ key: rep.email, fullName: rep.name }));
      }
      // td.TitleCompanyName && (signerDetails.fullName = td.TitleCompanySignedBy || rootDocData.fullName);
      //  console.log("signedTitleCompany",  "closingCompany", signerDetails);
      let ClosingCompanySigBlock = buildSignatureBlocks({ signers, type: "Authorized", rootDocData, requiredOpenFor: "TITLE_COMPANY", contractData });
      document.querySelectorAll('[data-signature-block="CLOSING_COMPANY"]')?.forEach((element) => {
        element.innerHTML = ClosingCompanySigBlock;
      });
      const signerTitleInputField = document.getElementById("SignerTitleField");
      if (signerTitleInputField) {
        signerTitleInputField.value = td?.SignerTitleInput || "";
      }
    }

    // persisting the signatures
    if (rootDocData && rootDocData.signatureInfo) {
      rootDocData.signatureInfo?.forEach((signatureBlock) => {
        handleSignatureCompletion({signatureBlock, signatureSequence: contractData?.signatureSequence});
      });
    }
  }
  // autofill the document date
  const dateFields = document.querySelectorAll('[name="DocumentDate"], [name="OriginalContractDate"]');
  if (td && ((!td["DocumentDate"] && !createOfferContractTypes.includes(rootDocData?.contractType)) || !td["OriginalContractDate"]) && rootDocData?.builtForSection !== "TEMPLATE" && rootDocData?.builtForSection !== "DOCUMENT_SET") {
    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const today = `${currentDate.getFullYear()}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    dateFields?.forEach((el) => {
      const fieldName = el.name;
      if (fieldName === "OriginalContractDate" && (createOfferContractTypes.includes(rootDocData?.contractType) || ["ERTB", "CB_ERTB", "ERTL", "ETCT"].includes(rootDocData?.contractType))) {
        if (!td[fieldName]) {
          td[fieldName] = today;
          el.value = today;
        }
      } else if (fieldName === "DocumentDate") {
        if (!td[fieldName]) {
          td[fieldName] = today;
          el.value = today;
        }
      }
    });
    localStorage.setItem(currentUrlId, JSON.stringify(td));
  }

  // adjusting widths of the price table inputs
  const priceTableinputs = document.querySelectorAll("[data-calculatepricetable]");
  if (priceTableinputs && priceTableinputs.length) {
    let maxWidth = 65;
    // Calculating the maximum width among all input values
    priceTableinputs?.forEach((input) => {
      const tempSpan = document.createElement("span");
      tempSpan.style.position = "absolute";
      tempSpan.style.visibility = "hidden";
      tempSpan.style.whiteSpace = "nowrap";
      tempSpan.textContent = input.value || "";
      document.body.appendChild(tempSpan);
      const computedWidth = tempSpan.offsetWidth + 2; // padding
      maxWidth = Math.max(maxWidth, computedWidth);
      document.body.removeChild(tempSpan);
    });
    // Applying the maximum width to all inputs
    priceTableinputs.forEach((input) => {
      input.style.width = `${maxWidth}px`;
    });
  }
  // && !getTransactionReportData > removed this condition from below as TO form was not saving automatically
  if (source !== "OFFER_IMPORT" && currentUrlId && typeof rootDocData === "object" && !rootDocData.documentId && rootDocData.contractType !== "TR") {
    dispatch(contractStoreHandle.autoSaveContract({ currentUrlId, contractAuthKey }));
  }
};

export default SetInitialValues;
